import React from 'react';
import { Box, CardActionArea, Divider, Typography } from '@mui/material';
import commafy from '../../../utils/commafyHelper';
import './report.scss';
interface ReportCardProps {
  title: string;
  bgColor: string;
  bgIcon: string;
  amount?: number;
  value?: number;
  icon: React.ReactNode;
}

const ReportCard: React.FC<ReportCardProps> = (props) => {
  const { title, icon, value, bgColor, bgIcon, amount = 0 } = props;

  return (
    <CardActionArea className='cardActionArea'>
      <Box className='card' bgcolor={bgColor} textAlign={amount ? 'center' : 'right'}>
        <Box className='header'>
          <Box className='icon' bgcolor={bgIcon}>
            {icon}
          </Box>
          <Typography className='title'>{title}</Typography>
        </Box>

        <Divider sx={{ backgroundColor: 'white', margin: '1rem 0', borderRadius: '0.5rem' }} />

        <Typography className='value'>
          {value ? value : `${commafy(amount)} ${amount !== 0 ? 'تومان' : ''} `}
        </Typography>
      </Box>
    </CardActionArea>
  );
};

export default ReportCard;
